// ============================================================================
// SETUP READINESS endpoints (ADR-0048).
// ============================================================================

import { buildEndpoint } from './base.endpoints';

export const setupEndpoints = {
  /** GET /api/v1/setup/readiness — the active entity's readiness (X-Entity-ID; X-Business-Unit-ID optional). */
  readiness: () => buildEndpoint('/setup/readiness'),
} as const;
